import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { OrgRouterHelperService } from '@cf/features/organizations/admin';
import { AccountService } from '@cf/temp/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimezoneConfirmationModalComponent } from './modals/timezone-confirmation/timezone-confirmation-modal.component';

@Component({
  selector: 'cf-app-container',
  template: `
    <div>
      <router-outlet></router-outlet>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppContainerPageComponent {
  #orgRouterHelperService = inject(OrgRouterHelperService);
  constructor(
    private readonly accountService: AccountService,
    private readonly modalService: NgbModal,
    private readonly router: Router,
    readonly route: ActivatedRoute,
  ) {
    this.handleTimezoneChanged();
  }

  redirectToDashboard(): void {
    if (this.router.url === '/') {
      void this.#orgRouterHelperService.navigate(['/dashboard']);
    }
  }

  handleTimezoneChanged(): void {
    const rejectedTimezone = this.accountService.account.ignored_timezone;
    if (
      rejectedTimezone === this.accountService.localTimezone ||
      this.accountService.isLocalTimezone
    ) {
      this.redirectToDashboard();
      return;
    }

    const modal = this.modalService.open(TimezoneConfirmationModalComponent, {
      size: 'medium',
    });

    modal.dismissed.subscribe(() => {
      this.accountService
        .updatePartialAccount({
          ignored_timezone: this.accountService.localTimezone,
        })
        .subscribe(() => {
          this.redirectToDashboard();
        });
    });

    modal.closed.subscribe(() => {
      this.accountService
        .updatePartialAccount({
          timezone: this.accountService.localTimezone,
        })
        .subscribe(() => this.redirectToDashboard());
    });
  }
}
